import React from 'react'
import { useCompleteInstallationValidation } from 'src/Libs/installations/hooks/installation-configuration/use-complete-installation-validation'
import { AccordionItem } from '@e3dc-react/shell/Elements/Accordion'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { usePlannedInstallationDevices } from 'src/Libs/installations/hooks/installation-configuration/use-planned-installation-devices'
import { DevicesTable } from './DevicesTable'
import { Button, Stack } from '@mui/material'
import { OptionalTooltipWrapper } from '@e3dc-react/shell/Elements/Tooltip'
import { useInstallationDeletionDialog } from 'src/Libs/installations/hooks/installation-configuration/use-installation-deletion-dialog'
import { useInstallationCompletionDialog } from 'src/Libs/installations/hooks/installation-configuration/use-complete-installation-dialog'
import { DeviceLinkModel, Installation } from 'src/Libs/installations'
import { useConfigSyncStatus } from 'src/Libs/installations/hooks/installation-configuration/use-config-sync'
interface Props {
  installationId: number
  installation?: Installation
  emcDeviceLink?: DeviceLinkModel
  emcDeviceLinkId?: string
}

const ComponentsList: React.FC<Props> = ({ installationId, installation, emcDeviceLink, emcDeviceLinkId }) => {
  const { t } = useCustomTranslation()
  const { devices, isEmcOnline } = usePlannedInstallationDevices(installationId, emcDeviceLinkId)
  const isSyncPossible = Boolean(emcDeviceLink?.deviceId && emcDeviceLink.pairingState === 'paired')
  const { data: syncDevices, isLoading: isSyncStatusLoading, isError: isSyncStatusError } = useConfigSyncStatus(installationId, isSyncPossible)
  const isSynced =
    !isSyncStatusLoading && !isSyncStatusError && Boolean(syncDevices?.length) && syncDevices?.every(device => device.state === 'done') === true
  const { openDeleteInstallationConfirmationDialog } = useInstallationDeletionDialog(installationId)
  const { openCompleteInstallationConfirmationDialog } = useInstallationCompletionDialog(installationId)
  const { isValid, validationStatus } = useCompleteInstallationValidation(devices, isEmcOnline, installation, isSynced)

  return (
    <AccordionItem title={t('installation-configuration.component-list.title')} expanded accordionDetailsSx={{ px: 4, py: 2 }}>
      <DevicesTable devices={devices} isEmcOnline={isEmcOnline} />
      <Stack direction={'row'} justifyContent={'flex-end'} alignItems={'center'} sx={{ mt: 2 }} gap={2}>
        <Button sx={{ width: { xs: '100%', md: 'auto' } }} onClick={openDeleteInstallationConfirmationDialog}>
          {t('installation-configuration.component-list.delete-installation')}
        </Button>
        <OptionalTooltipWrapper
          hasTooltip={!isValid}
          titleKey={'installation-configuration.component-list.complete-installation-disabled-tooltip'}
          titleValue={validationStatus}
          placement={'top'}
        >
          <Button
            variant="contained"
            sx={{ width: { xs: '100%', md: 'auto' } }}
            onClick={openCompleteInstallationConfirmationDialog}
            disabled={!isValid}
          >
            {t('installation-configuration.component-list.complete-installation')}
          </Button>
        </OptionalTooltipWrapper>
      </Stack>
    </AccordionItem>
  )
}

export default ComponentsList
